export interface DynamicFormType {
    id: number;
    name: string;
    isCommunityCalendar: boolean;
    sort: number;
    subtypes: DynamicFormSubtype[];
}

export interface DynamicFormSubtype {
    id: number;
    name: string;
    order: number;
}

export enum DynamicFormTypeId {
    BEK_SPORTS_SUPPORT = 1,
    GENERAL_SUPPORT = 2,
    COMMUNITY_CALENDAR_EVENTS = 3,
    DONATIONS_AND_SPONSORSHIPS = 4,
    REPORT_AN_OUTAGE = 5,
    RESIDENTIAL_SUPPORT = 6,
    BUSINESS_SUPPORT = 7,
    COMMUNITY_SUPPORT = 8,
    BEK_NEWS_SUPPORT = 9,
    BILLING_SUPPORT = 10,
    MOVE_MY_SERVICE = 11,
    OTHER = 12,
}

export enum DynamicFormSubtypeId {
    INTERNET = 1,
    PHONE = 2,
    TELEVISION = 3,
    SECURITY = 4,
    SURVEILLANCE = 5,
    CLOUD_SERVICES = 6,
    OTHER = 7,
    VOIP = 8,
    NURSE_CALL = 9,
    COMMUNITY_CALENDAR = 10,
    SPONSORSHIPS = 11,
    SCHOLARSHIPS = 12,
    COMMON_CENTS_GRANTS = 13,
    CROP_DAMAGE = 14,
    NONE = 15,
}
